/**
 * Money is always integer cents, and this product only ever transacts whole
 * dollars. Every amount that crosses an API boundary or reaches the database
 * satisfies `cents % 100 === 0`.
 */
/** One dollar, in cents. */
export const CENTS_PER_DOLLAR = 100;
/** Largest amount the 12-digit rank sort key can represent: $9,999,999,999.99. */
export const MAX_AMOUNT_CENTS = 999_999_999_999;
/** True when `cents` is a non-negative integer number of whole dollars. */
export function isWholeDollars(cents) {
    return (Number.isInteger(cents) &&
        cents >= 0 &&
        cents <= MAX_AMOUNT_CENTS &&
        cents % CENTS_PER_DOLLAR === 0);
}
/** Throws unless `cents` is a non-negative integer number of whole dollars. */
export function assertWholeDollars(cents, label = 'amount') {
    if (!Number.isInteger(cents)) {
        throw new RangeError(`${label} must be an integer number of cents`);
    }
    if (cents < 0) {
        throw new RangeError(`${label} must not be negative`);
    }
    if (cents > MAX_AMOUNT_CENTS) {
        throw new RangeError(`${label} exceeds the maximum supported amount`);
    }
    if (cents % CENTS_PER_DOLLAR !== 0) {
        throw new RangeError(`${label} must be a whole number of dollars`);
    }
}
/** Convert whole dollars to cents. */
export function dollarsToCents(dollars) {
    if (!Number.isInteger(dollars)) {
        throw new RangeError('dollars must be a whole number');
    }
    return dollars * CENTS_PER_DOLLAR;
}
/** Convert cents to whole dollars, rounding down. */
export function centsToDollars(cents) {
    return Math.floor(cents / CENTS_PER_DOLLAR);
}
/** Render cents as customer-facing copy, e.g. `240000` becomes `"$2,400"`. */
export function formatCents(cents) {
    const dollars = centsToDollars(cents);
    return `$${dollars.toLocaleString('en-US')}`;
}
//# sourceMappingURL=money.js.map